import { EnvironmentType } from 'app/app.environment'
import { environment } from 'environments/environment'
import { StorageError, StorageErrorCode, UploadTask } from 'firebase/storage'
import { FirebaseLemonaid } from '../../_angular/service/firebase-lemonaid.service'

const SIMULOINNIN_AVAIN = 'lisaaTositteitaSimulointi'

const SIMULOITAVAT_VIRHETILAT = ['jumissa', 'lahetysvirhe', 'tallennuspalvelu-ei-vastaa', 'token-jumissa', 'ai-luku-kaatuu'] as const
type SimuloitavaVirhetila = (typeof SIMULOITAVAT_VIRHETILAT)[number]

const eiKoskaanValmistu = <T>() => new Promise<T>(() => {})

const jumittuvaLahetys = () => ({ on: () => () => {}, cancel: () => true }) as unknown as UploadTask

const epaonnistuvaLahetys = () =>
  ({
    on: (_tapahtuma: string, _seuraava: unknown, virheessa: (virhe: StorageError) => void) => {
      setTimeout(() => virheessa(new StorageError(StorageErrorCode.RETRY_LIMIT_EXCEEDED, 'Simuloitu lähetysvirhe')), 2000)
      return () => {}
    },
    cancel: () => true,
  }) as unknown as UploadTask

const annaOhitukset = (tila: SimuloitavaVirhetila, firebase: FirebaseLemonaid): Partial<FirebaseLemonaid> => {
  switch (tila) {
    case 'jumissa':
      return { storageUpload: jumittuvaLahetys }
    case 'lahetysvirhe':
      return { storageUpload: epaonnistuvaLahetys }
    case 'tallennuspalvelu-ei-vastaa':
      return { storageUpload: jumittuvaLahetys, storageList: eiKoskaanValmistu }
    case 'token-jumissa':
      return { storageUpload: jumittuvaLahetys, authGetIdToken: eiKoskaanValmistu }
    case 'ai-luku-kaatuu':
      return {
        functionsCall: (nimi, ...muut) => (nimi === 'lueTositteenTiedotAi' ? Promise.reject(new Error('Simuloitu AI-luvun kaatuminen')) : firebase.functionsCall(nimi, ...muut)),
      }
  }
}

/**
 * Kehitysaikainen apu virhetilojen katselmointiin. Päälle selaimen konsolista:
 * localStorage.setItem('lisaaTositteitaSimulointi', 'jumissa') ja sivun uudelleenlataus.
 */
export function simuloiVirhetila(firebase: FirebaseLemonaid): FirebaseLemonaid {
  if (environment.environment === EnvironmentType.PRODUCTION) {
    return firebase
  }
  const tila = localStorage.getItem(SIMULOINNIN_AVAIN) as SimuloitavaVirhetila | null
  if (!tila) {
    return firebase
  }
  if (!SIMULOITAVAT_VIRHETILAT.includes(tila)) {
    console.warn(`Tuntematon simuloitava virhetila "${tila}". Vaihtoehdot: ${SIMULOITAVAT_VIRHETILAT.join(', ')}`)
    return firebase
  }

  console.warn(`Lisää tositteita: simuloidaan virhetilaa "${tila}". Pois päältä: localStorage.removeItem('${SIMULOINNIN_AVAIN}')`)
  const ohitukset = annaOhitukset(tila, firebase)
  return new Proxy(firebase, {
    get: (kohde, nimi) => {
      if (nimi in ohitukset) {
        return ohitukset[nimi as keyof FirebaseLemonaid]
      }
      const arvo = Reflect.get(kohde, nimi)
      return typeof arvo === 'function' ? arvo.bind(kohde) : arvo
    },
  })
}
